export default "__VITE_ASSET__77f88fbe__"